export const useIsInIframe = () => {
    if (import.meta.server) {
        const headers = useRequestHeaders(['sec-fetch-dest']);
        const dest = String(headers['sec-fetch-dest'] || '').toLowerCase();
        return dest === 'iframe';
    }

    return globalThis.self !== globalThis.top;
};
